module.exports = __webpack_public_path__ + "img/eamaster_logo_long.58998dc7.png";